// extracted by mini-css-extract-plugin
export default {"container":"tags-block_container__2gZhM","tag":"tags-block_tag__bjgQM","caseStyleTag":"tags-block_caseStyleTag__eUbHL","articleStyleTag":"tags-block_articleStyleTag__q+2NQ"};